import React from "react";
import "./statcard.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const StateCard = ({ title, more, count, view, path }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const onClickPoTable = () => {
    navigate(path);
  };

  let evaluationScore = null;
  let deliveryScore = null;

  if (title === t("Performance") && typeof count === "string") {
    const [evalStr, deliveryStr] = count?.split(" - ");
    evaluationScore = evalStr?.trim();
    deliveryScore = deliveryStr?.trim();
  }

  return (
    <>
      <div className="stat-card p-3">
        <div className="d-flex justify-content-between align-items-center">
          <p className="stat-card-title">{title}</p>
          <p>{more}</p>
        </div>
        <div className="d-flex justify-content-between align-items-center">
          {title === t("Performance") ? (
            <div>
              <p>
                {t("Evaluation Score")}: {evaluationScore || "-"}
              </p>
              <p>
                {t("Delivery Score")}: {deliveryScore || "-"}
              </p>
            </div>
          ) : (
            <h1 className="stat-card-count">{count}</h1>
          )}
          <a
            onClick={onClickPoTable}
            className="stat-card-view"
            style={{ cursor: "pointer" }}
          >
            {view}
          </a>
        </div>
      </div>
    </>
  );
};

export default StateCard;
